module.exports = __webpack_public_path__ + "static/img/12.6b53348c.png";